import { ProgressButtonComponent } from "@syncfusion/ej2-react-splitbuttons";
import * as React from "react";
import { DefaultHtmlAttributes } from "@syncfusion/ej2-react-base";
import useLoadingButton, { LoadingButtonProps } from "./useLoadingButton";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isNil } from "lodash";

/**No defaults set, with secondary styling*/
const LoadingButton: React.FC<
  LoadingButtonProps & {
    children?: React.ReactNode | React.ReactNode[];
  } & Readonly<DefaultHtmlAttributes>
> = (props) => {
  const {
    loadingState,
    isLoading,
    progressButtonComponent,
    onClickHandler,
    duration,
  } = useLoadingButton(
    props,
    props.buttonClassStyle || "e-info",
    props.defaultLoadingIdleContent || "",
    props.defaultLoadingProgressContent || "Loading",
    props.defaultLoadingSuccessContent || "Loaded"
  );

  return (
    <div
      className={classNames(
        "ucl-button",
        "ucl-loading-button",
        props.cssClass,
        {
          "ucl-loading-button-minimal": props.minimal,
        }
      )}
    >
      {loadingState && (
        <ProgressButtonComponent
          ref={progressButtonComponent}
          isPrimary={false}
          {...(() => {
            const {
              text,
              minimal,
              isLoading,
              loadingProgressContent,
              loadingSuccessContent,
              onClick,
              iconProps,
              buttonClassStyle,
              defaultLoadingIdleContent,
              defaultLoadingProgressContent,
              defaultLoadingSuccessContent,
              ...rest
            } = props;
            return rest;
          })()}
          cssClass={loadingState.cssClass}
          duration={duration}
          onClick={onClickHandler}
          disabled={props.disabled}
          key={`${loadingState?.content || "no-content"}-${
            loadingState?.cssClass || "no-class"
          }`}
        >
          <div
            className={classNames("ucl-loading-button-content-container", {
              "ucl-loading-button-content-minimal": props.minimal,
              "ucl-loading-button-content-icon-position-left":
                props.iconProps &&
                (props.iconPosition === "left" ||
                  (isNil(props.iconPosition) && props.text)),
              "ucl-loading-button-content-icon-position-right":
                props.iconProps && props.iconPosition === "right",
              "ucl-loading-button-content-icon-position-top":
                props.iconProps && props.iconPosition === "top",
              "ucl-loading-button-content-icon-position-bottom":
                props.iconProps && props.iconPosition === "bottom",
            })}
          >
            {props.iconProps && (
              <div className="ucl-loading-button-content-icon">
                <FontAwesomeIcon {...props.iconProps} />
              </div>
            )}
            <div className="ucl-loading-button-content">
              {props.children && !isLoading && props.children}
              {props.children && isLoading && <>{loadingState.content}</>}
              {!props.children && <>{loadingState.content}</>}
            </div>
          </div>
        </ProgressButtonComponent>
      )}
    </div>
  );
};
export default LoadingButton;
